import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateFilesQueries } from '@/api/hooks/useInvalidateFileQueries';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { getLocationFor } from '@trinity/chat-components';
import { TranscribeFileContext, ViewFileTranscriptContext } from './Context';

type Props =
  IWorkspaceId &
  IWorkspaceFileId &
  ITranscriptId &
  ChildrenProps;

export const TranscribeFileContainer = (props: Props) => {

  const navigate = useNavigate();
  //const invalidateFilePreviewQueries = useInvalidateFilePreviewQueries();
  const invalidateFilesQueries = useInvalidateFilesQueries();

  const chatApiClient = useChatApiClient();

  const transcribeMutation = useMutation({
    mutationKey: ['file.transcribe'],
    mutationFn: () => {
      return chatApiClient.workspacesFile.transcribeFile({
        fileId: props.fileId,
        workspaceId: props.workspaceId,
      });
    },
    onSuccess: () => {
      Toast.alert({
        title: 'File transcription started',
      });
      //invalidateFilePreviewQueries(props);
      invalidateFilesQueries();
    },
    onError: () => {
      Toast.error({
        title: 'Failed to start file transcription',
      });
    },
  });

  /*
  const importMutation = useMutation({
    mutationFn: () => {
      return $api.parseIntoTranscript({
        fileId: props.fileId,
        workspaceId: props.workspaceId,
      });
    },
    onSuccess: () => {
      Toast.alert({
        title: 'Transcript import started',
      });
      invalidateFilePreviewQueries(props);
      invalidateFilesQueries();
    },
    onError: () => {
      Toast.error({
        title: 'Failed to start transcript import',
      });
    },
  });
  */

  const viewTranscript = useCallback(() => {
    const location = getLocationFor.workspaces.transcript({
      transcriptId: props.transcriptId,
    });
    navigate(location);
  }, [navigate, props.transcriptId]);

  return (
    <TranscribeFileContext.Provider value={transcribeMutation.mutateAsync}>
      {/* <ImportTranscriptContext.Provider value={importMutation.mutateAsync}> */}
      <ViewFileTranscriptContext.Provider value={viewTranscript}>
        {props.children}
      </ViewFileTranscriptContext.Provider>
      {/* </ImportTranscriptContext.Provider> */}
    </TranscribeFileContext.Provider>
  );
};